export default __webpack_public_path__ + "locales/de/DownloadDialog.json?hash=60d0c13eb992d7d0b8d800909ae93713";